import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import * as d3 from 'd3'
import VueObserveVisibility from 'vue-observe-visibility'
import { ToggleButton } from 'vue-js-toggle-button'


Vue.use(VueObserveVisibility)

import { library } from '@fortawesome/fontawesome-svg-core'
import { faLongArrowAltRight } from '@fortawesome/free-solid-svg-icons'
import { faArrowCircleRight } from '@fortawesome/free-solid-svg-icons'
import { faAngleDown } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import i18n from './i18n'

library.add(faLongArrowAltRight)
library.add(faArrowCircleRight)
library.add(faAngleDown)

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.component('ToggleButton', ToggleButton)

Vue.filter('percentage', function (value, decimals) {
 if (!value) {
   value = 0
 }

 if (!decimals) {
   decimals = 0
 }

 let precision = Math.pow(10, - 2 - decimals);

 if (value < precision ) value = '< ' + (precision * 100);
 else if (value > 1 - precision ) value = '> ' + ((1 - precision) * 100);
 else {
   value = value * 100
   value = Math.round(value * Math.pow(10, decimals)) / Math.pow(10, decimals)
   value = value.toFixed(decimals);
 }

 value = value + ' %'
 if (i18n.locale == 'de') value = value.replace(".", ",")
 return value
})


Vue.filter('probability', function (value, decimals) {
  if (!value) {
    value = 0
  }

  if (!decimals) {
    decimals = 0
  }

  let precision = Math.pow(10, - 2 - decimals);

  if (value < precision ) value = '< ' + (precision * 100);
  else if (value > 1 - precision ) value = '> ' + ((1 - precision) * 100);
  else {
    value = value * 100
    value = Math.round(value * Math.pow(10, decimals)) / Math.pow(10, decimals)
    value = value.toFixed(decimals);
  }

  value = value + ' %'

  if (i18n.locale == 'de') value = value.replace(".", ",")

  return value
})

Vue.filter('plusminus', function (value) {
  let sign = value > 0 ? '+' : '-';

  value = Math.abs(value * 100).toFixed(1);

  if (i18n.locale == 'de') value = value.replace(".", ",")


  return sign + " " + value + " %";
})

Vue.filter('round', function (value, decimals) {
  if (!value) {
    value = 0
  }

  if (!decimals) {
    decimals = 0
  }

  value = Math.round(value * Math.pow(10, decimals)) / Math.pow(10, decimals)

  return value
})

Vue.filter('ceiling', function (value, decimals) {
  if (!value) {
    value = 0
  }

  if (!decimals) {
    decimals = 0
  }

  value = Math.ceil(value * Math.pow(10, decimals)) / Math.pow(10, decimals)

  return value
})

Vue.filter('date', function (value) {
  if (!value) return "";

  let time = d3.isoParse(value);

  return d3.timeFormat(i18n.t("format_date_long"))(time);
})

Vue.filter('dateshort', function (value) {
  if (!value) return "";

  let time = d3.isoParse(value);

  return d3.timeFormat(i18n.t("format_date_shorter"))(time);
})

Vue.filter('datetime', function (value) {
  if (!value) return "";

  let time = d3.isoParse(value);

  return d3.timeFormat(i18n.t("format_date_time"))(time);
})

Vue.filter('cap', function(value) {
  return value.charAt(0).toUpperCase() + value.slice(1);
})

Vue.config.productionTip = false

Vue.mixin({
  computed: {
    dashboard() {
      return this.$route.name && this.$route.name == 'dashboard';
    }
  },
})

new Vue({
  store,
  router,
  components: { App },
  i18n,
  template: `<App/>`
}).$mount('#app')